let Timeline = {
    setup: function(c) {
        //Banner Header
        let animation1 = new TimelineMax()
            .add([
                TweenMax.fromTo('#header .live-info-header .live-info', 1, {y: '0%'}, {y: '40%', ease: Linear.easeNone}),
            ]);

        let scene1 = new ScrollMagic.Scene({
                triggerElement: 'body',
                triggerHook: 'onLeave',
                duration: '50%'
            })
            .setTween(animation1)
            .addTo(c);
    }
};
